import memoize from 'lru-memoize';
import { createValidator, required, email, match, minLength, maxLength } from 'utils/validation';

const registerValidation = createValidator({
  username: [email, required],
  password: [required, minLength(8), maxLength(50)],
  passwordConfirm: [required, match('password')]
});

export default memoize(10)(registerValidation);
